export default __webpack_public_path__ + "static/media/menu11.87006468.png";